/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ContentMasterFieldVersionView } from './ContentMasterFieldVersionView';
import type { ContentMasterLanguageVersionsView } from './ContentMasterLanguageVersionsView';
import type { ContentMasterOtherSourceStatusView } from './ContentMasterOtherSourceStatusView';
import type { ContentMasterWawiExtendedFieldView } from './ContentMasterWawiExtendedFieldView';
import type { MarketplaceProductFieldsView } from './MarketplaceProductFieldsView';
export type ContentMasterProductView = {
    /**
     * DataSource UUID. With source + wawiArtikelId forms canonical identity for productKey.
     */
    dataSourceId?: string | null;
    /**
     * Base64URL(first 16 bytes SHA-256 of `{dataSourceId}:{source}:{wawiArtikelId}`)
     */
    productKey?: string;
    /**
     * Channel identifier — `plattform:N` (master / marketplace from `dbo.tPlattform`) or `shop:N` (shop instance from `dbo.tShop`). See GET /content-master/workspace-config.
     */
    source?: string;
    /**
     * Normalized language key (lowercase ISO 639-1 from Wawi when set, else kSprache as string)
     */
    language?: string;
    /**
     * Wawi article id (kArtikel)
     */
    wawiArtikelId?: number;
    /**
     * Article number (cArtNr)
     */
    sku?: string;
    /**
     * HAN (cHAN), if present in Wawi schema
     */
    han?: string;
    /**
     * Barcode / GTIN (cBarcode), if present in Wawi schema
     */
    gtin?: string;
    /**
     * Product title (tArtikelBeschreibung.cName)
     */
    title?: string;
    /**
     * Main image URL: JTL — tShop.cServerWeb + /media/image/product/{kArtikel}/md/{cBildname|basename(cQuelle)|cHash.jpg} when cQuelle is not already a URL; skips local disk paths. Amazon — full URL from cQuelle when http(s), else shop base + relative path. Null when no image row or URL cannot be built.
     */
    mainImageUrl?: string | null;
    /**
     * Short description (cKurzBeschreibung). Populated on detail only.
     */
    shortDescription?: string | null;
    /**
     * Full description (cBeschreibung). Populated on detail only.
     */
    description?: string | null;
    /**
     * SEO title tag (cTitleTag). Populated on detail only.
     */
    metaTitleTag?: string | null;
    /**
     * SEO meta keywords (cMetaKeywords). Populated on detail only.
     */
    metaKeywords?: string | null;
    /**
     * SEO meta description (cMetaDescription). Populated on detail only.
     */
    metaDescription?: string | null;
    /**
     * URL path / SEO slug of the product page for this channel (cUrlPfad — "URL-Pfad" in the Wawi article dialog). Populated on detail only. Generated values are normalized server-side to a slug (lowercase ASCII, umlauts transliterated, single hyphens). Listed in `generateDefaultExcludedFields`, i.e. it must NOT be pre-selected by a "generate all fields" action.
     */
    urlPath?: string | null;
    /**
     * Local Content Master status when a row exists; null if not persisted in S2G yet. The `bulk_*` values mark products that went through the asynchronous bulk-generation / bulk-apply pipeline.
     */
    processingStatus?: ContentMasterProductView.processingStatus | null;
    /**
     * S2G content_master_product UUID when row exists
     */
    contentMasterProductId?: string | null;
    /**
     * Statuses of the SAME Wawi article on OTHER sources (platforms / shops) within the same data source. Lets the UI show that a product is already being processed elsewhere. Empty array when no work exists on other sources.
     */
    otherSourceProcessing?: Array<ContentMasterOtherSourceStatusView>;
    /**
     * ISO 8601 timestamp of last successful apply to Wawi (content_master_product.last_saved_at); null if never applied or no S2G row
     */
    lastSavedAt?: string | null;
    /**
     * Per-product Wawi schema hint; reserved for v2. Null in list items.
     */
    wawiVersion?: string | null;
    /**
     * Reason of the last bulk-task failure (set when `processingStatus` is `bulk_generate_failed` / `bulk_apply_failed`). `null` otherwise.
     */
    bulkErrorMessage?: string | null;
    /**
     * Operation of the last bulk submit (from the `bulk_config` snapshot). Lets the client tell a TRANSLATE task apart from a generate one — bulk translation reuses the `bulk_generate_*` statuses. `null` when the product never went through a bulk pipeline.
     */
    bulkOperation?: ContentMasterProductView.bulkOperation | null;
    /**
     * Current draft field values keyed by API name. Populated on detail only when draft exists.
     */
    draft?: Record<string, string> | null;
    /**
     * All field versions keyed by API name, each containing a list of version objects. Populated on detail only. Mirror of `languageVersions[language].versions` for the requested language; kept for backward compatibility.
     */
    versions?: Record<string, Array<ContentMasterFieldVersionView>> | null;
    /**
     * Cross-language draft state for this product, keyed by storage language code (same shape as the `language` field — lowercase ISO 639-1 from Wawi when set, else kSprache as string). Populated on detail only. Includes every language that has at least one stored version (drafts and applied), so the client can mark which languages have unsaved work and which were already applied. Within each entry, a field is "unsaved" when the newest version (first item of the list) has `isCurrent = false`; when it is `true`, that field is fully synced to Wawi.
     */
    languageVersions?: Record<string, ContentMasterLanguageVersionsView> | null;
    /**
     * Unified list of Wawi product extensions (article attributes, Eigene Felder, Merkmale). Each item carries a `type` discriminator (attribut|eigene|merkmal) and only the fields relevant to its type are non-null. Detail only.
     */
    wawiExtendedFields?: Array<ContentMasterWawiExtendedFieldView> | null;
    /**
     * Live max char length per core field (read from `INFORMATION_SCHEMA.COLUMNS` of the connected Wawi database — `dbo.tArtikelBeschreibung`). Keyed by API name (`title`, `shortDescription`, `description`, `metaTitleTag`, `metaKeywords`, `metaDescription`, `urlPath`). Value is a positive integer for sized `NVARCHAR(N)` columns and `null` for `NVARCHAR(MAX)` (no column-level limit). Per-marketplace UI limits (e.g. Amazon title 200) are still enforced separately at export time. Detail only.
     */
    fieldMaxLengths?: Record<string, number | null> | null;
    /**
     * Core field API names that a "generate all fields" action MUST leave unchecked by default (opt-in only). Today: `["urlPath"]` — regenerating a URL path would replace a slug that is already live/indexed in the shop. The user can still tick such a field manually; the backend generates exactly what `POST /content-master/generate.fields` contains and never filters it. Detail only.
     */
    generateDefaultExcludedFields?: Array<string> | null;
    /**
     * Marketplace listing fields for this product, resolved LIVE from the requested `source` channel + selected category (SCX). Present (non-null) only when `source` is a supported marketplace channel (shop:N → amazon/otto/kaufland/metro). In the single-product GET this is the FULL section (attributes, titlePreview, warnings). In the product LIST it is a LIGHT summary — only `marketplace`, `status` (ok | category_not_selected), `kCategory`, `categoryName` are populated (attributes empty) so the UI can flag "no category" cheaply.
     */
    marketplace?: MarketplaceProductFieldsView | null;
};
export namespace ContentMasterProductView {
    /**
     * Local Content Master status when a row exists; null if not persisted in S2G yet. The `bulk_*` values mark products that went through the asynchronous bulk-generation / bulk-apply pipeline.
     */
    export enum processingStatus {
        NEW = 'new',
        IN_PROGRESS = 'in_progress',
        DONE = 'done',
        BULK_GENERATE_QUEUED = 'bulk_generate_queued',
        BULK_GENERATE_IN_PROGRESS = 'bulk_generate_in_progress',
        BULK_GENERATE_DONE = 'bulk_generate_done',
        BULK_GENERATE_FAILED = 'bulk_generate_failed',
        BULK_APPLY_QUEUED = 'bulk_apply_queued',
        BULK_APPLY_IN_PROGRESS = 'bulk_apply_in_progress',
        BULK_APPLY_FAILED = 'bulk_apply_failed',
        LISTING_GENERATE_QUEUED = 'listing_generate_queued',
        LISTING_GENERATE_IN_PROGRESS = 'listing_generate_in_progress',
        LISTING_GENERATE_DONE = 'listing_generate_done',
        LISTING_GENERATE_FAILED = 'listing_generate_failed',
    }
    /**
     * Operation of the last bulk submit (from the `bulk_config` snapshot). Lets the client tell a TRANSLATE task apart from a generate one — bulk translation reuses the `bulk_generate_*` statuses. `null` when the product never went through a bulk pipeline.
     */
    export enum bulkOperation {
        GENERATE_ALL_FIELDS = 'generate_all_fields',
        TRANSLATE_ALL_FIELDS = 'translate_all_fields',
        APPLY_TO_WAWI = 'apply_to_wawi',
        LISTING_GENERATE_FIELDS = 'listing_generate_fields',
        LISTING_APPLY_TO_WAWI = 'listing_apply_to_wawi',
    }
}

